// State codes for GSTIN generation
export const stateCodes = {
  'Andaman and Nicobar Islands': '35',
  'Andhra Pradesh': '37',
  'Arunachal Pradesh': '12',
  'Assam': '18',
  'Bihar': '10',
  'Chandigarh': '04',
  'Chhattisgarh': '22',
  'Dadra and Nagar Haveli': '26',
  'Daman and Diu': '25',
  'Delhi': '07',
  'Goa': '30',
  'Gujarat': '24',
  'Haryana': '06',
  'Himachal Pradesh': '02',
  'Jammu and Kashmir': '01',
  'Jharkhand': '20',
  'Karnataka': '29',
  'Kerala': '32',
  'Ladakh': '38',
  'Lakshadweep': '31',
  'Madhya Pradesh': '23',
  'Maharashtra': '27',
  'Manipur': '14',
  'Meghalaya': '17',
  'Mizoram': '15',
  'Nagaland': '13',
  'Odisha': '21',
  'Puducherry': '34',
  'Punjab': '03',
  'Rajasthan': '08',
  'Sikkim': '11',
  'Tamil Nadu': '33',
  'Telangana': '36',
  'Tripura': '16',
  'Uttar Pradesh': '09',
  'Uttarakhand': '05',
  'West Bengal': '19'
};

// Generate GSTIN from state and PAN
export const generateGSTIN = (stateCode, pan) => {
  // GSTIN format: 2 digit state code + 10 digit PAN + 1 + Z + checksum
  const code = stateCodes[stateCode] || '07'; // Default to Delhi
  const panUpper = pan.toUpperCase();
  // Simple checksum calculation (in reality, it's more complex)
  const checksum = Math.floor(Math.random() * 10);
  return `${code}${panUpper}1Z${checksum}`;
};

// Generate 15-digit TRN
export const generateTRN15 = () => {
  const timestamp = Date.now().toString().slice(-10);
  const random = Math.floor(Math.random() * 100000).toString().padStart(5, '0');
  return timestamp + random;
};

// Registration status types
export const RegistrationStatus = {
  DRAFT: 'draft',
  PART_A_COMPLETE: 'part_a_complete',
  PART_B_COMPLETE: 'part_b_complete',
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Get registration session from localStorage
export const getRegistrationSession = () => {
  const session = localStorage.getItem('practiq_registration_session');
  return session ? JSON.parse(session) : null;
};

// Save registration session to localStorage
export const saveRegistrationSession = (data) => {
  const existing = getRegistrationSession() || {};
  const updated = { ...existing, ...data, updatedAt: new Date().toISOString() };
  localStorage.setItem('practiq_registration_session', JSON.stringify(updated));
  return updated;
};

// Clear registration session
export const clearRegistrationSession = () => {
  localStorage.removeItem('practiq_registration_session');
};

// Generate mock email for TRN
export const generateTRNEmail = (trn, email, legalName) => {
  const now = new Date();
  return {
    id: `email_${Date.now()}`,
    subject: 'Temporary Reference Number (TRN) for GST Registration',
    from: 'donotreply@demogstpractiq.in',
    to: email,
    date: now.toISOString(),
    isRead: false,
    body: `
Dear Taxpayer,

Greetings from GST Portal!

Your application for GST Registration has been successfully submitted.


═══════════════════════════════════════════════════
        YOUR TEMPORARY REFERENCE NUMBER (TRN)
═══════════════════════════════════════════════════

                  ${trn}

═══════════════════════════════════════════════════

Legal Name: ${legalName}
Application Date: ${now.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
Application Time: ${now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}


Please save this TRN for completing Part-B of GST Registration.

You can complete Part-B within 15 days from TRN generation.


Regards,
PractiQ
`
  };
};

// Generate approval email
export const generateApprovalEmail = (gstin, legalName, email) => {
  const now = new Date();
  return {
    id: `email_${Date.now()}`,
    subject: 'GST Registration Certificate - Application Approved',
    from: 'donotreply@gst.gov.in',
    to: email,
    date: now.toISOString(),
    isRead: false,
    body: `
Dear Taxpayer,

Greetings from GST Portal!

We are pleased to inform you that your application for GST Registration has been APPROVED.

═══════════════════════════════════════════════════
            GST REGISTRATION CERTIFICATE
═══════════════════════════════════════════════════

GSTIN: ${gstin}

Legal Name: ${legalName}
Registration Date: ${now.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
Status: ACTIVE

═══════════════════════════════════════════════════

NEXT STEPS:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1. Download your GST Registration Certificate from the GST Portal.

2. You are now required to file GST Returns as per the applicable schedule:
   • GSTR-1: Details of Outward Supplies (Monthly/Quarterly)
   • GSTR-3B: Monthly Summary Return

3. First return filing is due by the 11th of the following month.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

IMPORTANT: Please ensure timely filing of returns to avoid penalties.

For any queries, please contact GST Helpdesk at 1800-103-4786 or visit www.gst.gov.in

Regards,
Goods and Services Tax Network (GSTN)

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
This email was sent by the GST Portal (www.gst.gov.in)
© 2024 Goods and Services Tax Network. All Rights Reserved.
`
  };
};

// Get mock inbox emails
export const getMockInbox = () => {
  const inbox = localStorage.getItem('practiq_mock_inbox');
  return inbox ? JSON.parse(inbox) : [];
};

// Add email to mock inbox
export const addToMockInbox = (email) => {
  const inbox = getMockInbox();
  inbox.unshift(email);
  localStorage.setItem('practiq_mock_inbox', JSON.stringify(inbox));
  return inbox;
};

// Mark email as read
export const markEmailAsRead = (emailId) => {
  const inbox = getMockInbox();
  const updated = inbox.map(e => e.id === emailId ? { ...e, isRead: true } : e);
  localStorage.setItem('practiq_mock_inbox', JSON.stringify(updated));
  return updated;
};

// Delete email from mock inbox
export const deleteEmail = (emailId) => {
  const inbox = getMockInbox();
  const updated = inbox.filter(e => e.id !== emailId);
  localStorage.setItem('practiq_mock_inbox', JSON.stringify(updated));
  return updated;
};

// Clear mock inbox
export const clearMockInbox = () => {
  localStorage.removeItem('practiq_mock_inbox');
};
